<template>
  <SearchInput
    v-model="teamAssetsFilterTitle"
    class="tw:max-w-full"
  />
</template>

<script setup>
import SearchInput from '@/components/ui/search-input.vue'
import { useTeamAssets } from './use-team-assets'

defineOptions({
  name: 'TeamAssetSearch',
})

const { teamAssetsFilterTitle } = useTeamAssets()
</script>
